<app-steps [current]="stepAtual()" [total]="totalSteps()"></app-steps>
<div class="cabecalho">
  <div>
    <h2 class="title">Escolha a modalidade do Imposto de Renda</h2>
    <p class="description">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce leo tortor, vehicula sed
      aliquet nec, varius ut est. Phasellus blandit massa ac feugiat porttitor.
    </p>
  </div>
  <vivest-button variant="outline" size="sm" (click)="showModal()">
    <vivest-icon slot="icon-right" name="arrow-up-right" source="feather"></vivest-icon>
    Veja o comparativo completo
  </vivest-button>
</div>

@if (simulacaoIndisponivel()) {
  <div class="simulacao-indisponivel" role="alert">
    <p>Não foi possível calcular os valores do Imposto de Renda.</p>
    <vivest-button variant="outline" size="sm" (click)="recalcularSimulacao()">
      Tentar novamente
    </vivest-button>
  </div>
}

<div class="modalidades" role="radiogroup" aria-label="Modalidade do Imposto de Renda">
  @for (modalidade of modalidades(); track modalidade.value) {
    <div class="modalidade">
      <!-- Só o cabeçalho com o radio recebe o destaque de selecionado; os valores ficam abaixo, em um card com borda. -->
      <label
        class="modalidade__opcao"
        [class.modalidade__opcao--checked]="regimeSelecionado() === modalidade.value"
      >
        <input
          class="modalidade__input"
          type="radio"
          name="modalidade-imposto"
          [value]="modalidade.value"
          [checked]="regimeSelecionado() === modalidade.value"
          [attr.aria-describedby]="'valores-modalidade-' + modalidade.value"
          (change)="regimeSelecionado.set(modalidade.value)"
        />
        <span class="modalidade__titulo">{{ modalidade.titulo }}</span>
      </label>
      <dl class="modalidade__descricao" [id]="'valores-modalidade-' + modalidade.value">
        <!-- Antecipação de saldo à vista escolhida na etapa 2: vem antes dos valores mensais. -->
        @if (modalidade.antecipacao; as antecipacao) {
          <div class="modalidade__linha">
            <dt>Valor bruto da antecipação</dt>
            <dd>{{ formatarMoeda(antecipacao.valorBruto) }}</dd>
          </div>
          <div class="modalidade__linha">
            <dt>Imposto de Renda da antecipação</dt>
            <dd>{{ formatarMoeda(antecipacao.valorImpostoRenda) }}</dd>
          </div>
          <div class="modalidade__linha modalidade__linha--liquido modalidade__linha--fim-grupo">
            <dt>Valor líquido da antecipação</dt>
            <dd><span class="moeda">R$</span> {{ formatarValor(antecipacao.valorLiquido) }}</dd>
          </div>
        }
        <div class="modalidade__linha">
          <dt>Valor Bruto Mensal do benefício</dt>
          <dd>{{ formatarMoeda(modalidade.beneficioBrutoMensal) }}</dd>
        </div>
        <div class="modalidade__linha">
          <dt>Imposto de Renda do benefício</dt>
          <dd>{{ formatarMoeda(modalidade.impostoRenda) }}</dd>
        </div>
        <div class="modalidade__linha modalidade__linha--liquido">
          <dt>Valor líquido Mensal do benefício</dt>
          <dd><span class="moeda">R$</span> {{ formatarValor(modalidade.valorLiquido) }}</dd>
        </div>
      </dl>
    </div>
  }
</div>

<div class="dependentes">
  <h4 class="dependentes__titulo">Informe a quantidade de dependentes do seu Imposto de Renda</h4>
  <vivest-select
    class="dependentes__select"
    label=""
    aria-label="Quantidade de dependentes"
    placeholder="Selecione"
    [status]="mensagemErroDependentes() ? 'error' : 'default'"
    [errorMessage]="mensagemErroDependentes()"
    [options]="dependentesOptions"
    [value]="quantidadeDependentes()?.toString() ?? ''"
    (change)="onDependentesChange($event)"
  ></vivest-select>
</div>

<div class="d-flex justify-content-center align-items-center buttons-requerimento">
  <vivest-button variant="outline" size="md" (click)="onReturn()"> Voltar </vivest-button>
  <vivest-button variant="primary" size="md" [disabled]="!podeContinuar()" (click)="onSubmit()">
    <vivest-icon slot="icon-right" name="arrow-right" source="feather"></vivest-icon>
    Continuar para Beneficiários
  </vivest-button>
</div>

<vivest-modal
  #modalComparativo
  [hasIcon]="false"
  [open]="openModal()"
  (vivest-close)="closeModal()"
  style="--vivest-modal-width: 868px"
>
  <div slot="heading"></div>
  <div slot="description">
    <div>
      <div class="close">
        <button type="button" (click)="closeModal()">
          <img src="assets/images/icons/x.svg" alt="Fechar" />
        </button>
      </div>
      <div class="mb-0 text-start">
        <h4 class="modal-title">Regime Progressivo</h4>
        <div class="modal-text top-16">
          <p>
            Benefício de prestação mensal. Quanto maior a renda, maior o percentual. IR na fonte
            mensal com ajuste na declaração anual. Como funciona:
          </p>
          <ul>
            <li>A alíquota do Imposto de Renda (IR) <b>aumenta conforme o valor resgatado</b></li>
            <li>
              Alíquotas: Vão de <b>0% a 27,5% sendo que no resgate é aplicado 15%</b> a título de
              adiantamento do valor que será tributado na declaração de ajuste anual.
            </li>
            <li>
              Ajuste Anual: A retenção na fonte (15% para resgates) é adiantamento. O valor total
              será ajustado na sua declaração anual de IR, somando-se a outras rendas e podendo
              resultar em imposto a pagar ou restituir.
            </li>
          </ul>
        </div>
        <div class="regressivo">
          <div class="regressivo__coluna">
            <h4 class="modal-title">Regime Regressivo</h4>
            <div class="modal-text top-16">
              <p>
                Tributação definitiva, por alíquota decrescente conforme o período de acumulação de
                cada contribuição. IR retido na fonte, sem ajuste na declaração anual.
              </p>
            </div>
          </div>
          <div class="regressivo__coluna">
            <table class="tabela-ir">
              <thead>
                <tr>
                  <th scope="col">Prazo de acumulação</th>
                  <th scope="col" class="text-right">Percentual de IR</th>
                </tr>
              </thead>
              <tbody>
                @for (aliquota of aliquotasRegressivas; track aliquota.prazo) {
                  <tr>
                    <td>{{ aliquota.prazo }}</td>
                    <td class="text-right">{{ aliquota.percentual }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="top-32">
        <vivest-button slot="actions" variant="outline" size="md" (click)="closeModal()"
          >Fechar</vivest-button
        >
      </div>
    </div>
  </div>
</vivest-modal>
